import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Toast, {
      modelValue: _ctx.notificationItems,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.notificationItems) = $event)),
      position: "bottom-right"
    }, null, 8, ["modelValue"])
  ]))
}